<mat-card>
  <mat-card-title>Exportar Para Diseño</mat-card-title>
  <mat-card-subtitle>Seleccione la fecha de la edición a generar.</mat-card-subtitle>
  <mat-card-content>
    <div fxLayout="row">
      <div fxFlex></div>
      <mat-form-field>
        <input matInput [matDatepicker]="editionDate" placeholder="Seleccione una fecha" (dateChange)="onChange($event)">
        <mat-datepicker-toggle matSuffix [for]="editionDate"></mat-datepicker-toggle>
        <mat-datepicker #editionDate></mat-datepicker>
      </mat-form-field>
      <div fxFlex></div>
    </div>
    <div fxLayout="row">
        <div fxFlex></div>
        <div *ngIf="!exist">Para la fecha seleccionada no se han encontrado ediciones.</div>
        <div fxFlex></div>
      </div>
  </mat-card-content>
</mat-card>
